// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();

$(document).ready(function() {
    $('.recherche').click(function(){
        $('.search-container').toggleClass('active');
				$('.recherche').toggleClass('active');
				$('.search-field').focus();
				$('.quicklinks-front').removeClass('active');
				$('.megamenu').removeClass('active');
    });
});

$(document).ready(function() {
    $('.quickactive').click(function(){
        $('.quicklinks-front').toggleClass('active');
				$('.search-container').removeClass('active');
				$('.megamenu').removeClass('active');
    });
});

$(document).ready(function() {
    $('.close-quicklinks').click(function(){
        $('.quicklinks-front').toggleClass('active');
    });
});

$(document).ready(function() {
    $('.close-mega-menu').click(function(){
        $('.megamenu').removeClass('active');
    });
});

$(document).ready(function() {
    $('.menuville').on("mouseover", function (){
				$('.menu-tourisme,.menu-services,.menu-loisirs').removeClass('active');
        $('.menu-ville').toggleClass('active');
				$('.quicklinks-front').removeClass('active');
				$('.search-container').removeClass('active');
    });
});

$(document).ready(function() {
    $('.menuloisirs').on("mouseover", function (){
				$('.menu-tourisme,.menu-services,.menu-ville').removeClass('active');
        $('.menu-loisirs').toggleClass('active');
				$('.quicklinks-front').removeClass('active');
				$('.search-container').removeClass('active');
    });
});

$(document).ready(function() {
    $('.menuservices').on("mouseover", function (){
				$('.menu-tourisme,.menu-loisirs,.menu-ville').removeClass('active');
        $('.menu-services').toggleClass('active');
				$('.quicklinks-front').removeClass('active');
				$('.search-container').removeClass('active');
    });
});

$(document).ready(function() {
    $('.menutourisme').on("mouseover", function (){
				$('.menu-services,.menu-loisirs,.menu-ville').removeClass('active');
        $('.menu-tourisme').toggleClass('active');
				$('.quicklinks-front').removeClass('active');
				$('.search-container').removeClass('active');
    });
});

$(document).ready(function() {
	if (location.hash !== null && location.hash !== "") {
			$(location.hash + ".collapse").collapse("show");
			$([document.documentElement, document.body]).animate({
        scrollTop: $(location.hash).offset().top
	    }, 100);
	}
});


// Instantiate the Bootstrap carousel
var multipleCardCarousel = document.querySelector(
  "#carouselExampleControls"
);
if (window.matchMedia("(min-width: 768px)").matches) {
  var carousel = new bootstrap.Carousel(multipleCardCarousel, {
    interval: false,
  });
  var carouselWidth = $(".carousel-inner")[0].scrollWidth;
  var cardWidth = $(".carousel-item").width();
  var scrollPosition = 0;
  $("#carouselExampleControls .carousel-control-next").on("click", function () {
    if (scrollPosition < carouselWidth - cardWidth * 4) {
      scrollPosition += cardWidth;
      $("#carouselExampleControls .carousel-inner").animate(
        { scrollLeft: scrollPosition },
        600
      );
    }
  });
  $("#carouselExampleControls .carousel-control-prev").on("click", function () {
    if (scrollPosition > 0) {
      scrollPosition -= cardWidth;
      $("#carouselExampleControls .carousel-inner").animate(
        { scrollLeft: scrollPosition },
        600
      );
    }
  });
} else {
  $(multipleCardCarousel).addClass("slide");
}
